<template>
  <div
    v-if="object[listName]?.count || object[listName]?.length"
    class="relative group"
    @mouseenter="mouse_over_badge = true"
    @mouseleave="mouse_over_badge = false">
    <component :is="icon" v-if="icon" class="ml-2 w-5 h-5" aria-hidden="true" />
    <div
      v-if="
        !mouse_over_badge ||
          (mouse_over_badge && object.summary && !Object.entries(object.summary[listName]).filter(([i, c]) => c > 0).length)
      "
      :class="[
        primary_color,
        'text-white text-xs text-center flex justify-center items-center rounded-full w-5 absolute -right-2.5 -top-2.5 h-5'
      ]">
      {{ object[listName].count || object[listName]?.length }}
    </div>
    <div v-else-if="mouse_over_badge && object.summary" class="h-[40px] w-4 absolute -top-3 -right-2 flex flex-col">
      <div
        v-for="[item_status, item_count] in Object.entries(object.summary[listName]).filter(([i, c]) => c > 0)"
        :key="object.id + item_status"
        :class="[
          status_color_mapped[item_status],
          'opacity-0 group-hover:delay-500 transition ease-in-out group-hover:opacity-80 text-white text-xs text-center flex justify-center items-center rounded-full w-4  h-4'
        ]">
        {{ item_count }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    object: {
      type: Object,
      required: true
    },
    icon: {
      type: Object,
      default: null
    },
    listName: {
      type: String,
      default: "tasks"
    }
  },
  data() {
    return {
      primary_count: -1,
      status_color_mapped: {
        missed: "bg-status-error-red",
        cancelled: "bg-status-error-red",
        overdue: "bg-status-warning-yellow",
        pending: "dark:bg-dark-light-blue bg-light-light-blue",
        "in-progress": "dark:bg-dark-brand-blue bg-light-brand-blue",
        completed: "bg-status-success-green"
      },
      mouse_over_badge: false
    }
  },

  computed: {
    primary_color() {
      let max_count = -1
      let primary = null
      if (this.object.summary) {
        Object.entries(this.object.summary[this.listName]).forEach(([st, count]) => {
          if (count > max_count) {
            max_count = count
            primary = st
            this.primary_count = max_count
          }
        })
      }
      if (!primary) {
        primary = "pending"
      }
      return this.status_color_mapped[primary]
    }
  }
}
</script>
